import type { HTMLProps, PropsWithChildren } from 'react'
import { cn } from '@/src/utils/styles'

const SeparatorLine = () => {
  return <div className='border-t-1 border-button-outline-border flex-grow' />
}

interface SeparatorProps extends HTMLProps<HTMLDivElement> {}

const Separator = ({
  className,
  children,
}: PropsWithChildren<SeparatorProps>) => {
  return (
    <div className={cn('flex w-full my-5 items-center gap-4', className)}>
      {children && (
        <>
          <SeparatorLine />
          {children}
          <SeparatorLine />
        </>
      )}
      {children === undefined && <SeparatorLine />}
    </div>
  )
}

export default Separator
